function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M1.90979 0.383643C2.02076 0.27267 2.07625 0.217183 2.13902 0.193463C2.21002 0.166634 2.28836 0.166633 2.35936 0.19346C2.42213 0.217178 2.47762 0.272663 2.58859 0.383631L6.48568 4.28105L10.3831 0.383643C10.494 0.272669 10.5495 0.217181 10.6123 0.193461C10.6833 0.166633 10.7616 0.166633 10.8326 0.19346C10.8954 0.217178 10.9509 0.272665 11.0619 0.383636L11.7755 1.09729C11.8865 1.20826 11.942 1.26375 11.9657 1.32652C11.9925 1.39752 11.9925 1.47586 11.9657 1.54686C11.942 1.60963 11.8865 1.66512 11.7755 1.77609C11.7755 1.77609 8.3657 5.18607 7.53878 6.013L6.82513 6.72666C6.71416 6.83764 6.65867 6.89312 6.5959 6.91684C6.5249 6.94367 6.44655 6.94367 6.37556 6.91685C6.31279 6.89313 6.2573 6.83764 6.14633 6.72668L6.4857 7.06608L1.19614 1.77611C1.08517 1.66514 1.02968 1.60965 1.00596 1.54688C0.979133 1.47588 0.979133 1.39754 1.00596 1.32654C1.02968 1.26377 1.08516 1.20828 1.19614 1.09731L1.90979 0.383643Z",
  fill: "#333333"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/ArrowDownIcon.efda7fee.svg";
export { SvgComponent as ReactComponent };